module.exports = __webpack_public_path__ + "img/big4-6.14b27e3d.jpg";